// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2_iOR","tab":"Tabs_tab__-Vfpb","tabActive":"Tabs_tabActive__nWLxZ"};